import { render, staticRenderFns } from "./factoryReportBasic.vue?vue&type=template&id=daa3f636&"
import script from "./factoryReportBasic.vue?vue&type=script&lang=js&"
export * from "./factoryReportBasic.vue?vue&type=script&lang=js&"
import style0 from "./factoryReportBasic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports